import React, { useState, useEffect } from 'react';
import { Card, CardBody, Col, Button } from 'reactstrap';
import ModalChangeStatus from "./ModalChangeStatus";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faTimesCircle, faCheckCircle, faCheckSquare, faCoffee } from '@fortawesome/fontawesome-free-solid';


const VenueStatus = ({ venueInfo }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeStatus,setActiveStatus] = useState("Not Available");

  useEffect(()=>{
      if(venueInfo.v_active == 1)
          setActiveStatus("Active");
      else if(venueInfo.v_active == 0)
          setActiveStatus("Inactive");
  },[activeStatus]);

  return (
    <Col md={12} xl={3} lg={6} xs={12}>
      <Card>
        <CardBody className="dashboard__card-widget  p-3">
          <div className="card__title">
            <h5 className="bold-text">Venue Status</h5>
          </div>
          <div className="card__body">
              {(activeStatus === "Not Available" || activeStatus === 'Inactive')
                  ? <h3><FontAwesomeIcon icon="times-circle" style={{color:'#FF0000'}}/> {activeStatus}</h3>
                  : <h3><FontAwesomeIcon icon="check-circle" style={{color:'#adff2f'}}/> {activeStatus}</h3>
              }
              <ModalChangeStatus/>
          </div>


        </CardBody>
      </Card>
    </Col>
  );
};

export default VenueStatus;
